<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { computed } from 'vue'
import ChargemapPass from '../../images/ChargemapPass.vue'

const props = defineProps({
    compatible: {
        type: Boolean,
        required: true
    },
    drawer: {
        type: Boolean,
        default: false
    },
    croppedPass: {
        type: Boolean,
        default: false
    }
})

const containerClasses = computed(() =>
    cva(
        'flex items-center justify-center gap-3.5 p-4 text-[#004f84] bg-lb-100 rounded-lg font-inter overflow-hidden',
        {
            variants: {
                drawer: {
                    true: 'flex-col max-w-[440px] text-center md:text-[21px] font-medium md:leading-[25px]',
                    false: 'flex-row max-w-[550px]'
                }
            }
        }
    )({ drawer: props.drawer })
)

const gtmClasses = computed(() =>
    props.compatible ? 'gtm-CTAOrderPass' : 'gtm-CTAEnSavoirPlus'
)

const cmpButtonSizeClass = computed(() => (props.drawer ? 'large' : 'medium'))

const pathToEmit = computed(() =>
    props.compatible ? 'pass/purchase/step1' : 'pass'
)

const emits = defineEmits(['click'])
</script>

<template>
    <div :class="containerClasses">
        <ChargemapPass
            :class="[croppedPass ? '-ml-6 w-[75px]' : 'w-[86px]']"
            class="shrink-0"
        />

        <div v-if="compatible">
            {{ $t('order.order') }}
            <span class="font-bold">{{ $t('chargemap_pass') }}</span>
            <span>&nbsp;</span>
            <span>{{ $t('order.charge_station') }}</span>
        </div>
        <div v-else>
            {{ $t('more.with') }}
            <span class="font-bold">{{ $t('chargemap_pass') }}</span>
            <span>{{ $t('more.easy_charging') }}</span>
        </div>
        <ChargemapB2CButton
            type="primary"
            :size="cmpButtonSizeClass"
            :class="gtmClasses"
            custom-classes-for-base-button="w-max"
            @click="emits('click', pathToEmit)"
        >
            <template v-if="compatible" #icon>
                <IconCaddie class="size-5" />
            </template>
            {{ compatible ? $t('order.order_now') : $t('more.learn_more') }}
        </ChargemapB2CButton>
    </div>
</template>
